import React, { useState } from "react";
import { FiX, FiMail } from "react-icons/fi";
import { useAuth } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";
import "./AuthModal.css";

export default function AuthModal() {
  const { loginModalOpen, closeLoginModal, signInWithEmail } = useAuth();
  const { texts } = useLanguage();
  const t = texts.auth || {};
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  if (!loginModalOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    setError("");
    try {
      await signInWithEmail(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.message || t.sendFailed || "Failed to send login link");
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    closeLoginModal();
    setSent(false);
    setError("");
  };

  return (
    <div className="auth-modal__overlay" onClick={handleClose}>
      <div
        className="auth-modal__dialog"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="auth-modal__close"
          onClick={handleClose}
          aria-label="Close"
        >
          <FiX />
        </button>
        <h2 className="auth-modal__title">{t.loginTitle || "ログイン"}</h2>
        {sent ? (
          <p className="auth-modal__message">
            {t.checkEmail || "ログインリンクをメールで送信しました。メール内のリンクを開いてください。"}
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="auth-modal__form">
            <p className="auth-modal__message">
              {t.magicLinkHint || "メールアドレスを入力するとログインリンクを送信します。"}
            </p>
            <input
              type="email"
              required
              className="auth-modal__input"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error ? <p className="auth-modal__error" role="alert">{error}</p> : null}
            <button type="submit" className="auth-modal__submit" disabled={sending}>
              <FiMail />
              {sending ? (t.sending || "送信中…") : (t.sendLoginLink || "ログインリンクを送信")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
